export default "__VITE_ASSET__5tdqBx47__"